export default {
    type: 'hero-with-card',
    name: 'Hero With Card',
    // thumbnail: require('./assets/thumbnail.png'),
    components: {
        root: {
            name: 'ModuleHeroWithCard',
            loader: () => import('./ModuleHeroWithCard')
        },
        form: {
            name: 'ModuleHeroWithCardForm',
            loader: () => import('./ModuleHeroWithCardForm')
        }
    }
};
